import { Box, Heading, Text } from '@chakra-ui/react';
import { format } from 'date-fns';

type Props = {
  firstName?: string;
};

export default function WelcomeHeader({ firstName }: Props) {
  const dateLabel = format(new Date(), 'EEEE, MMMM d').toUpperCase();
  const name = firstName?.trim() || 'there';

  return (
    <Box mt={7} mb={5}>
      <Text
        fontSize='xs'
        fontWeight='bold'
        letterSpacing='widest'
        color='brand.solid'
        mb={1.5}
        textTransform='uppercase'
      >
        {dateLabel}
      </Text>
      <Heading
        as='h1'
        fontSize={{ base: '3xl', md: '4xl' }}
        fontWeight='bold'
        color='gray.900'
        letterSpacing='-0.02em'
        lineHeight={1.1}
      >
        Welcome,{' '}
        <Text as='span' color='brand.solid' fontStyle='italic' fontWeight='semibold'>
          {name}
        </Text>
        <Text as='span' color='brand.solid'>
          .
        </Text>
      </Heading>
      <Text fontSize='sm' color='gray.500' mt={2}>
        Pick up where you left off — or start something new.
      </Text>
    </Box>
  );
}
